import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { ToolbarType } from '../../types';
var toolbarTypeToInputMethod = _defineProperty(_defineProperty({}, ToolbarType.PRIMARY, INPUT_METHOD.TOOLBAR), ToolbarType.FLOATING, INPUT_METHOD.FLOATING_TB);
export var getInputMethod = function getInputMethod(toolbarType) {
  return toolbarTypeToInputMethod[toolbarType];
};